//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
export default {
  props: {
    earlyWarningData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    minSum: {
      type: String,
      default: '0'
    },
    marginTop: {}
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    this.getsiteWarnList();
    console.log('mounted');

    if (this.earlyWarningData.length > 5) {
      this.Inter = setInterval(function () {
        setTimeout(function () {
          if (_this.earlyWarningData.length > _this.minSum) {
            _this.earlyWarningData.push(_this.earlyWarningData[0]); // 将数组的第一个元素添加到数组的


            _this.earlyWarningData.shift(); //删除数组的第一个元素

          }
        }, 500);
      }, 1500);
    }
  },
  watch: {
    moveState: function moveState(value) {
      if (value) {
        this.overflow = 'auto';
      } else {
        this.overflow = 'hidden';
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.Inter);
  },
  methods: {
    getsiteWarnList: function getsiteWarnList() {
      var _this2 = this;

      // 请求数据
      var params = {
        column: 'warn_time',
        scopeId: 259,
        scope: 1,
        st: 54,
        category: 1
      };
      getAction('/online/warn', params).then(function (res) {
        if (res.success) {
          _this2.earlyWarningData = res.result.records;
        }
      });
    },
    toggleState: function toggleState() {
      var _this3 = this;

      console.log('123');
      this.moveState = !this.moveState;

      if (this.moveState) {
        clearInterval(this.Inter);
      } else {
        var data = JSON.parse(JSON.stringify(this.earlyWarningData));
        this.earlyWarningData = [];
        setTimeout(function () {
          _this3.earlyWarningData = data;
          _this3.Inter = setInterval(function () {
            setTimeout(function () {
              if (_this3.earlyWarningData.length > _this3.minSum) {
                _this3.earlyWarningData.push(_this3.earlyWarningData[0]); // 将数组的第一个元素添加到数组的


                _this3.earlyWarningData.shift(); //删除数组的第一个元素

              }
            }, 500);
          }, 1000);
        }, 10);
      }
    },
    init: function init() {
      var _this4 = this;

      this.Inter = setInterval(function () {
        setTimeout(function () {
          if (_this4.earlyWarningData.length > _this4.minSum) {
            _this4.earlyWarningData.push(_this4.earlyWarningData[0]); // 将数组的第一个元素添加到数组的


            _this4.earlyWarningData.shift(); //删除数组的第一个元素

          }
        }, 500);
      }, 1000);
    }
  }
};